import React, { useContext } from "react";
import { getHotel, getTerm } from '../../../queries';
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { OrderContext } from "../../../contexts/order_context";
import SpinLoading from "../../../../shared/spin_loading";
import InfoItem from "./item";
import OrderField from "../shared/order_field";

const OrderInfo = ({ product, term }) => {
  const { hotelId } = useContext(OrderContext);
  const { data: hotelData, isFetching: hotelIsFetching } = useQuery(
    ["hotel"],
    () => getHotel({ hotelId }),
    {
      onError: (error) => alert(error),
    }
  );

  return (
    <OrderField title={I18n.t("js.order.fields.order_title")}>
      {hotelIsFetching ? (
        <SpinLoading show={hotelIsFetching} />
      ) : (
        <>
          <h3>
            {hotelData?.name}
            <span className="stars">
              {[...Array(hotelData?.stars)].map((_, i) => {
                return <i key={i} className="fas fa-star"></i>;
              })}
            </span>
          </h3>
          <div className="row order-form__block-content">
            <div className="img-wrap col-md-12 col-lg-5">
              <img src={hotelData?.image_url} alt={hotelData?.name} />
            </div>
            <div className="col-md-12 col-lg-7 main-info">
              {term?.date_start && (
                <InfoItem
                  title={I18n.t("js.order.info.from")}
                  icon={"calendar-check"}
                  value={term?.date_start}
                />
              )}
              {term?.date_end && (
                <InfoItem
                  title={I18n.t("js.order.info.to")}
                  icon={"calendar-times"}
                  value={term?.date_end}
                />
              )}
              {term?.transports && (
                <InfoItem
                  title={I18n.t("js.order.info.transport")}
                  icon={"plane-departure"}
                  value={term?.transports}
                />
              )}
              {hotelData?.region && (
                <InfoItem
                  title={I18n.t("js.order.info.region")}
                  icon={"map-marker-alt"}
                  value={hotelData?.region}
                />
              )}
              {hotelData?.localizations && (
                <InfoItem
                  title={I18n.t("js.order.info.destination")}
                  icon={"map-marker-alt"}
                  value={
                    <div
                      dangerouslySetInnerHTML={{
                        __html: hotelData?.localizations,
                      }}
                    />
                  }
                />
              )}
              {product?.tour_type && (
                <InfoItem
                  title={I18n.t("js.order.info.tour_type")}
                  icon={"umbrella-beach"}
                  value={product?.tour_type.display_name}
                />
              )}
            </div>
          </div>
        </>
      )}
    </OrderField>
  );
};

export default OrderInfo;
